import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import React from "react";
import IAPI from "../../../../models/IAPI";
import IIntegration from "../../../../models/IIntegration";
import { useSelectableApis } from "../../hooks/integrationApiHooks";
import IntegrationAPISelectRow from "./IntegrationAPISelectRow";

export interface IIntegrationAPISelectProps {
  token: string;
  name: string;
  integration: IIntegration;
  selectedAPIs: IAPI[];
  setSelectedAPIs: (apis: IAPI[]) => void;
}

const IntegrationAPISelectTable = (props: IIntegrationAPISelectProps) => {
  const { name, token, integration, selectedAPIs, setSelectedAPIs } = props;
  const selectableAPIs = useSelectableApis(token, integration.System.Name);

  const handleAPIsUpdate = (api: IAPI, add: boolean) => {
    if (add) {
      setSelectedAPIs(selectedAPIs.concat(api));
    } else {
      setSelectedAPIs(selectedAPIs.filter(entry => entry.ID != api.ID));
    }
  };

  const getRows = () => {
    return selectableAPIs.map((api, index) => (
      <IntegrationAPISelectRow key={index} api={api} isSelected={selectedAPIs.some(entry => entry.ID == api.ID)} onAPIToggle={handleAPIsUpdate} />
    ));
  };

  return (
    <TableContainer>
      <Table aria-label={`${name}Table`}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Method</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{getRows()}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default IntegrationAPISelectTable;
